
import { defineComponent, ref, computed } from "vue";
import { GameUtils } from "@/utils/GameUtils";
import { Game } from "@/_models/Game";
import { useStore } from "vuex";
import { useRoute } from "vue-router";
import { useMeta } from "vue-meta";

// Import Swiper Vue.js components
import SwiperClass, { Navigation, Pagination, Autoplay, /* add some modules if you need */ } from "swiper";

SwiperClass.use([Navigation, Pagination, Autoplay]);

import { Swiper, SwiperSlide } from 'vue-awesome-swiper'

// import "swiper/css/bundle";
import 'swiper/swiper-bundle.min.css'
import 'swiper/swiper.min.css'


export default defineComponent({
  name: "viewGamersDashboard",
  components: {
    Swiper,
    SwiperSlide,
  },
  setup() {
    const onSwiper = (swiper) => {
      // console.log(swiper);
    };
    const onSlideChange = () => {
      // console.log('slide change');
      imageActive.value = false;
    };
    const route = useRoute();
    const store = useStore();
    const label = computed(() => {
      return store.getters['config/configLabel'];
    });
    const metaTitle = ref('MetX Games Dashboard');
    const metaDescription = ref('MetX Games Dashboard Description');
    useMeta({ title: metaTitle.value, description: metaDescription.value });
    const featuredTitle = ref("Featured Game's Title Will Go Here");
    const questionTitle = ref("Lorem ipsum dolor sit amet, consectetur adipiscing elit.");
    const questionDesc = ref("Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas semper ante eu neque vulputate, non dictum mi finibus. Phasellus maximus vehicula nisl. ");
    const coinTitle = ref("Top Xar Coins");
    const coinName = ref("XARTempo");
    const coinSubtitle = ref("Temporary Subtitle");
    const coinNum = ref("5,324");
    const iconNum = ref("512+");
    const iconTitle = ref("Dummy Title Here");
    const games = ref([]);
    const displayGames = ref([]);
    const publishedGames = ref([]);
    const featuredGames = ref([]);
    const latestGames = ref([]);
    const sortGamesTab = ref("trending");
    const assetURL = computed(() => {
      return store.getters['config/assetUrl'];
    });
    const Genres = ref([]);
    const sortedGenre = ref([]);
    const Action = ref([]);
    const Adventure = ref([]);
    const Simulation = ref([]);
    const Strategy = ref([]);
    const Sports = ref([]);
    const Fantasy = ref([]);
    const Arcade = ref([]);
    const Horror = ref([]);
    const headerImage = ref('');
    const imageActive = ref(false);

    const sortGamesTrending = async () => {
      games.value = await GameUtils.fetchAllPublishedGames();
      displayGames.value = games.value;
    }

    const sortGamesLatest = async () => {
      games.value = await GameUtils.fetchAllPublishedGames();
      const nestedSort = (prop1, prop2 = null, direction = 'asc') => (e1, e2) => {
        const a = prop2 ? e1[prop1][prop2] : e1[prop1],
          b = prop2 ? e2[prop1][prop2] : e2[prop1],
          sortOrder = direction === "asc" ? 1 : -1
        return (a < b) ? -sortOrder : (a > b) ? sortOrder : 0;

      }
      displayGames.value = games.value.sort(nestedSort("game", "created", "desc"));
    }


    (async () => {
      games.value = await GameUtils.fetchAllPublishedGames();
      featuredGames.value = await GameUtils.fetchFeaturedGames();

      Genres.value = await GameUtils.fetchGenreCount();
      const nestedSort = (prop1, prop2 = null, direction = 'asc') => (e1, e2) => {
        const a = prop2 ? e1[prop1][prop2] : e1[prop1],
          b = prop2 ? e2[prop1][prop2] : e2[prop1],
          sortOrder = direction === "asc" ? 1 : -1
        return (a < b) ? -sortOrder : (a > b) ? sortOrder : 0;

      }

      displayGames.value = games.value;


      sortedGenre.value = Genres.value.sort(nestedSort("count", null, "desc"));

              // Callback for IntersectionObserver
        const callback = function(entries) {
          entries.forEach(entry => {

            // Is the element in the viewport?
            if (entry.isIntersecting) {

              // Add the fadeIn class:
              entry.target.classList.add("motion-safe:animate-fadeIn");
            } else {

              // Otherwise remove the fadein class
              entry.target.classList.remove("motion-safe:animate-fadeIn");
            }
          });
        };

            // Get all the elements you want to show on scroll
        const targets = document.querySelectorAll(".js-show-on-scroll");

        // Set up a new observer
        const observer = new IntersectionObserver(callback);

        // Loop through each of the target
        targets.forEach(function(target) {
          // Hide the element
          target.classList.add("opacity-0");

          // Add the element to the watcher
          observer.observe(target);
        });
    })()

    const loadGames = () => {
      displayGames.value = games.value;
    };
    loadGames();

    const changeImage = (image) => {
      headerImage.value = image;
      setTimeout(() => headerImage.value = image, 81);
      setTimeout(() => imageActive.value = true, 81);
    };

    const hideImage = () => {
      imageActive.value = false;
      setTimeout(() => headerImage.value = null, 80);
      setTimeout(() => imageActive.value = false, 81);
      imageActive.value = false;
    };


    return {
      onSwiper,
      onSlideChange,
      sortGamesLatest,
      sortGamesTrending,
      changeImage,
      hideImage,
      modules: [Navigation, Pagination, Autoplay],
      games,
      label,
      featuredTitle,
      questionTitle,
      questionDesc,
      coinTitle,
      coinName,
      coinSubtitle,
      coinNum,
      iconNum,
      iconTitle,
      assetURL,
      sortGamesTab,
      displayGames,
      latestGames,
      publishedGames,
      featuredGames,
      sortedGenre,
      Action,
      Adventure,
      Simulation,
      Strategy,
      Sports,
      Fantasy,
      Arcade,
      Horror,
      headerImage,
      imageActive,
    };
  },
});


